import {
  Box,
  DialogActions,
  DialogContent,
  Typography,
} from "@material-ui/core"
import ButtonRounded from "components/Common/ButtonRounded"
import PropTypes from "prop-types"
import React from "react"

import useStyles from "./styles"

const CreatedMessage = ({ email, handleClose }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <DialogContent className={classes.contentContainer}>
        <Typography color="primary" variant="h2" className={classes.title}>
          {`Invitation sent to ${email}`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="center" width="100%">
          <ButtonRounded
            color="primary"
            variant="outlined"
            onClick={handleClose}
            type="button"
          >
            Close
          </ButtonRounded>
        </Box>
      </DialogActions>
    </Box>
  )
}

CreatedMessage.propTypes = {
  email: PropTypes.string,
  handleClose: PropTypes.func,
}

export default CreatedMessage
